import script from "./StandardA4X2EB.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardA4X2EB.vue?vue&type=script&setup=true&lang=js"

import "./StandardA4X2EB.vue?vue&type=style&index=0&id=d7178c6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7178c6a"]])

export default __exports__